import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueGtm from '@gtm-support/vue2-gtm'
import VueBrowserUpdate from '@sum.cumo/vue-browserupdate'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import '@babel/polyfill'
require('dotenv').config()
const GTM_ID = process.env.GTM_ID || 'GTM-W9W8X89'
Vue.use(VueBrowserUpdate, {
  options: {
    required: { e: -4, f: -3, o: -3, s: 12, c: -3, },
    style: 'bottom',
    insecure: true,
  },
  test: process.env.NODE_ENV === 'development',
})
Vue.use(VueGtm, {
  id: GTM_ID,
  defer: false,
  enabled: true,
  debug: process.env.NODE_ENV === 'development',
  loadScript: true,
  vueRouter: router,
  ignoredViews: [],
  trackOnNextTick: false,
})

Vue.prototype.$eventHub = new Vue()

Vue.prototype.$message = (message) => store.commit('snackbar/addMessage', message)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
